import { translate } from '@/domains/core/localization/translate';
export const {
  frequentlyBoughtTitle,
  similarityTitle,
  similaritySubtitle
} = translate({
  "frequentlyBoughtTitle": "Inspired by your preferences ",
  "similarityTitle": "You may also like",
  "similaritySubtitle": "Products to match your needs"
});